module.exports = __webpack_public_path__ + "a1c5deb1c9da145b092f93bae42ce272.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-14.png
// module id = 3275
// module chunks = 0